import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BreadcrumbService, IBreadcrumb } from './breadcrumb.service';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'workspace-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  imports: [NzBreadCrumbModule, RouterModule, TranslateModule],
  styleUrls: ['./breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbComponent {
  readonly #breadcrumbService = inject(BreadcrumbService);
  readonly breadcrumbs = this.#breadcrumbService.breadcrumbs;

  public getBreadcrumbUrl(breadcrumb: IBreadcrumb): string {
    return breadcrumb.redirectIsBlocked ? null : breadcrumb.url;
  }

  public onLinkClick(event: MouseEvent, breadcrumb: IBreadcrumb): void {
    if (breadcrumb?.customOnClickFn) {
      event.preventDefault();
      event.stopPropagation();
      breadcrumb.customOnClickFn();
    }
  }
}
